export const contactsData = {
    email: 'webdeveshverma@gmail.com',
    phone: '+917060596109',
    address: '320 devlock street, 110001, New Delhi, India ',

    sheetAPI: 'https://sheetdb.io/api/v1/tt5b8x0x5sbmo'
}